import React, { Component } from 'react';
import './Signup.css';

class Signup extends Component {
 render() {
    return (
      <div className="Signup">
        <div className="lander">
          <h2>Contact <a href="mailto:support@raas.freshservice.com?Subject=REQ:%20OAS%20Web%20account" target="_middle">Riverbed PS</a> to request OAS access.</h2>
        </div>
      </div>
    );
  }
}
export default Signup;


// WEBPACK FOOTER //
// ./src/containers/Signup.js